import React from 'react';
import scaleSize from '../../utils/scale-size';

export default () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={scaleSize(192)}
    height={scaleSize(192)}
    viewBox="0 0 192 192"
  >
    <g fill="none" fillRule="evenodd" stroke="#9F9F9F">
      <path
        strokeLinecap="round"
        strokeWidth="12"
        d="M38.81 119.988C48.189 142.318 70.264 158 96 158c34.242 0 62-27.758 62-62 0-21.626-11.072-40.666-27.857-51.76C120.352 37.768 108.616 34 96 34c-22.082 0-41.468 11.545-52.452 28.927M116 116L96 96.002"
      />
      <path fill="#9F9F9F" strokeLinejoin="round" strokeWidth="8" d="M32 52l20 20H32z" />
      <path strokeLinecap="round" strokeWidth="12" d="M96 96.004V64" />
    </g>
  </svg>
);
